import React from "react";
import styled from 'styled-components';
import I10n from '../../../features/i10n';
import { SeTabbar } from '@se/web-ui-react';
import { configurationModuleType } from '../../../constants';
import Scrollbars from 'react-custom-scrollbars';
import MsxIcons from '../../msx-icons';
import { computeTimeCycle } from '../../../utils/time-cycle-calculation';
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../../color-constants";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-top: 16px;
  align-items: stretch;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 800px) {
    min-height: auto;
  }
  ${props => props.fullScreenEnabled && `
    min-height: auto;
  `}
  border-top: 2px solid #cccccc;
`;

const NavigationTab = styled.nav`
  display: flex;
`;
const NavigationTabItem = styled.a``;

const TabContent = styled.div`
  background-color: #F4F4F4;
  display: flex;
  flex: 1 1 auto;
  padding: 0 10px;
`;

const TableContainer = styled.div`
  flex: 1 1 auto;
  margin-bottom: 20px;
  margin-right: 20px;
`;

const Row = styled.div`
  display: flex;
  ${props => props.bgColor ? `background-color : ${props.bgColor}` : ''}
`;

const IoTypeTableWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  border-bottom: 1px solid ${SECONDARY_COLOR};
  border-bottom: 1px solid var(--se-primary, ${SECONDARY_COLOR});
  margin-top: 100px;
  margin-bottom: 10px;
  margin-right: 10px;
`;

const HeaderIoTypes = styled.div`
  width: 200px;
  padding: 5px;
  display: flex;
  justify-content: center;
  border-right: 1px solid white;
`;

const HeaderTotals = styled.div`
  width: 50px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid white;
`;

const HeaderTitle = styled.span`
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  font-size: 10px;
  border-right: 1px solid white;
`;

const HeaderReference = styled.div`
  position : relative;
  width: 30px;
  border-right: 1px solid white;
`;

const HeaderReferenceWrapper = styled.div`
  position: absolute;
  transform: rotate(-90deg);
  transform-origin: left;
  left: 15px;
  bottom: 0px;
  white-space: nowrap;
`;

const HeaderReferenceText = styled.span`
  display: block;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  font-size: 10px;
`;

const IoGroupSection = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${SECONDARY_COLOR};
  border-top: 1px solid var(--se-primary, ${SECONDARY_COLOR});
  border-left: 1px solid ${SECONDARY_COLOR};
  border-left: 1px solid var(--se-primary, ${SECONDARY_COLOR});
`;

const IoTypeDescriptionCell = styled.div`
  width: 200px;
  padding: 5px;
  border-right: 1px solid ${SECONDARY_COLOR};
  border-right: 1px solid var(--se-primary, ${SECONDARY_COLOR});
  font-size: 10px;
  ${props => props.color ? `color : ${props.color}` : ''}
`;

const IoTypeTotalCell = styled.div`
  width: 50px;
  padding: 5px;
  border-right: 1px solid ${SECONDARY_COLOR};
  border-right: 1px solid var(--se-primary, ${SECONDARY_COLOR});
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.color ? `color : ${props.color}` : ''}
`;

const IoTypeNumberCell = styled.div`
  width: 20px;
  box-sizing: content-box !important;
  padding: 5px;
  border-right: 1px solid ${SECONDARY_COLOR};
  border-right: 1px solid var(--se-primary, ${SECONDARY_COLOR});
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TimeCycleWrapper = styled.div`
  border: 1px solid ${SECONDARY_COLOR};
  border: 1px solid var(--se-primary, ${SECONDARY_COLOR});
  padding: 5px 5px;
  font-size: 12px;
  width: 200px;
`;

const TimeCycleLabel = styled.span`
    color: ${SECONDARY_COLOR};
    color: var(--se-primary, ${SECONDARY_COLOR});
`;

const TimeCycleHint = styled.span`
  margin-top: 5px;
  font-style: italic;
  font-size: 12px;
`;


const display_all_islands_types = 'full';
const display_main_island_types = 'main';

class ModalIOTypes extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      displayKey: display_all_islands_types,
      slotIslandSelected: null,
      islandSelected: null,
      islandConfigurationSelected: null
    }
  }

  renderAllIslandsTypes = (configuration) => {
    const ioGroups = configuration.fullConfigurationIOGroups();
    const configurations = [configuration, ...configuration.ioIslands.map(island => island.configuration)];
    return (
      <IoTypeTableWrapper>
        <Row>
          <HeaderIoTypes>
            <HeaderTitle>
              {I10n.get('saved_configuration.export.pdf.io_type')}
            </HeaderTitle>
          </HeaderIoTypes>
          <HeaderTotals>
            <HeaderTitle>
              {I10n.get('saved_configuration.export.pdf.totals')}
            </HeaderTitle>
          </HeaderTotals>
          {configurations.map((config, idx) => {
            const referenceText = config.name;
            return (
              <HeaderReference key={idx}>
                <HeaderReferenceWrapper>
                  <HeaderReferenceText>
                    {referenceText}
                  </HeaderReferenceText>
                </HeaderReferenceWrapper>
              </HeaderReference>
            );
          })}
        </Row>
        {ioGroups.map((ioGroup, index) => {
          const ioTypesWithNumber = ioGroup.ioTypesWithNumber;
          return (
            <IoGroupSection key={index}>
              <Row>
                <IoTypeDescriptionCell color={SECONDARY_COLOR}>
                  {I10n.getOrDefault(`io_groups.${ioGroup.groupName}`, ioGroup.groupName, 'data')}
                </IoTypeDescriptionCell>
                <IoTypeTotalCell color={SECONDARY_COLOR}>
                  {ioGroup.total}
                </IoTypeTotalCell>
                {configurations.map((conf, index) => {
                  return (
                    <IoTypeNumberCell key={index}>
                    </IoTypeNumberCell>
                  );
                })}
              </Row>
              {ioTypesWithNumber.map((ioTypeWithNumber, index) => {
                const rowColor = index % 2 === 0 ? '#ecedf1' : 'white';
                return (
                  <Row key={index} bgColor={rowColor}>
                    <IoTypeDescriptionCell>
                      {I10n.getOrDefault(`io_types.${ioTypeWithNumber.ioType.id}`, ioTypeWithNumber.ioType.text, 'data')}
                    </IoTypeDescriptionCell>
                    <IoTypeTotalCell>
                      {ioTypeWithNumber.number}
                    </IoTypeTotalCell>
                    {configurations.map((conf, index) => {
                      const ioGroupObj = conf.ioGroupsAsObject();
                      return (
                        <IoTypeNumberCell key={index}>
                          {ioGroupObj[ioGroup.groupName]?.ioTypesWithNumber[ioTypeWithNumber.ioType.id]?.number}
                        </IoTypeNumberCell>
                      );
                    })}
                  </Row>
                );
              })}
            </IoGroupSection>
          );
        })}
      </IoTypeTableWrapper>
    );
  }

  renderIslandIOTypes = (islandConfiguration) => {
    const ioGroups = islandConfiguration.ioGroups();
    const references = islandConfiguration.pdfModules();
    const timeCycle = computeTimeCycle(this.state.islandSelected);
    let referenceIndex = 1;
    return (
      <>
        <IoTypeTableWrapper>
          <Row>
            <HeaderIoTypes>
              <HeaderTitle>
                {I10n.get('saved_configuration.export.pdf.io_type')}
              </HeaderTitle>
            </HeaderIoTypes>
            <HeaderTotals>
              <HeaderTitle>
                {I10n.get('saved_configuration.export.pdf.totals')}
              </HeaderTitle>
            </HeaderTotals>
            {references.map((reference, idx) => {
              const referenceText = (reference.moduleType == null || configurationModuleType.cartridges === reference.moduleType) ?
                `${reference.id}`
                :
                `${referenceIndex++} - ${reference.id}`
                ;
              return (
                <HeaderReference key={idx}>
                  <HeaderReferenceWrapper>
                    <HeaderReferenceText>
                      {referenceText}
                    </HeaderReferenceText>
                  </HeaderReferenceWrapper>
                </HeaderReference>
              );
            })}
          </Row>
          {ioGroups.map((ioGroup, index) => {
            const ioTypesWithNumber = ioGroup.ioTypesWithNumber;
            return (
              <IoGroupSection key={index}>
                <Row>
                  <IoTypeDescriptionCell color={SECONDARY_COLOR}>
                    {I10n.getOrDefault(`io_groups.${ioGroup.groupName}`, ioGroup.groupName, 'data')}
                  </IoTypeDescriptionCell>
                  <IoTypeTotalCell color={SECONDARY_COLOR}>
                    {ioGroup.total}
                  </IoTypeTotalCell>
                  {references.map((mod, index) => {
                    return (
                      <IoTypeNumberCell key={index}>
                      </IoTypeNumberCell>
                    );
                  })}
                </Row>
                {ioTypesWithNumber.map((ioTypeWithNumber, index) => {
                  const rowColor = index % 2 === 0 ? '#ecedf1' : 'white';
                  return (
                    <Row key={index} bgColor={rowColor}>
                      <IoTypeDescriptionCell>
                        {I10n.getOrDefault(`io_types.${ioTypeWithNumber.ioType.id}`, ioTypeWithNumber.ioType.text, 'data')}
                      </IoTypeDescriptionCell>
                      <IoTypeTotalCell>
                        {ioTypeWithNumber.number}
                      </IoTypeTotalCell>
                      {references.map((mod, index) => {
                        const moduleIOTypes = mod.ioTypesAsObject();
                        return (
                          <IoTypeNumberCell key={index}>
                            {moduleIOTypes[ioTypeWithNumber.ioType.id]?.number}
                          </IoTypeNumberCell>
                        );
                      })}

                    </Row>

                  );
                })}
              </IoGroupSection>
            );
          })}
        </IoTypeTableWrapper>
        {timeCycle > 0 &&
          <>
            <TimeCycleWrapper>
              <TimeCycleLabel>{`${I10n.get('saved_configuration.export.pdf.io_type.time_cycle')} `}</TimeCycleLabel>
              <span>{timeCycle}</span>
              <span>{I10n.get('unit.ms', 'data')}</span>
            </TimeCycleWrapper>
            <TimeCycleHint>{I10n.get('saved_configuration.export.pdf.io_type.time_cycle.hint')}</TimeCycleHint>
          </>
        }
      </>
    );
  }

  renderTabOptions = (configuration) => {
    return (<React.Fragment>
      <NavigationTab>
        <NavigationTabItem
          className={this.state.displayKey === display_all_islands_types ? 'active' : ''}
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              displayKey: display_all_islands_types,
              slotIslandSelected: null,
              islandSelected: null,
              islandConfigurationSelected: null
            });
          }}
        >
          {I10n.get('saved_configuration.export.pdf.io_type.full_configuration')}
        </NavigationTabItem>
        <NavigationTabItem
          className={this.state.displayKey === display_main_island_types ? 'active' : ''}
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              displayKey: display_main_island_types,
              slotIslandSelected: null,
              islandSelected: configuration,
              islandConfigurationSelected: configuration
            });
          }}>
          {configuration.name}
        </NavigationTabItem>
        {configuration.ioIslands.map((island, idx) => {
          return (
            <NavigationTabItem
              className={this.state.slotIslandSelected === island.slot ? 'active' : ''}
              key={idx}
              onClick={(e) => {
                e.preventDefault();
                this.setState({
                  displayKey: null,
                  slotIslandSelected: island.slot,
                  islandSelected: island,
                  islandConfigurationSelected: island.configuration
                });
              }}>
              {island.configuration.name}
            </NavigationTabItem>
          );
        })}
      </NavigationTab>

    </React.Fragment>);
  }

  renderTabContent = (configuration) => {
    return (
      <TableContainer id="modal-io-types-tableContainre">
        {
          this.state.displayKey === display_all_islands_types ?
            this.renderAllIslandsTypes(configuration)
            :
            this.renderIslandIOTypes(this.state.islandConfigurationSelected)
        }

      </TableContainer>
    )
  }

  handleButtonClick = () => this.props.onButtonClick();

  render = () => {
    return (
      <Container>
        <Header id="modal-io-types-header">
          <TitleWrapper id="modal-io-types-titleWrapper">
            <Title id="modal-io-types-title">{I10n.get('screen.config_editor.preview.io_types')}</Title>
            <CloseIcon onClick={(e) => {
              e.preventDefault();
              this.props.closeModal();
            }}>
              <MsxIcons name="close"></MsxIcons>
            </CloseIcon>
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <Body id="modal-io-types-body">
          <ContentWrapper id="modal-io-types-contentWrapper"></ContentWrapper>
          <SeTabbar id="modal-io-types-seTabbar" color="alternative" option="content" overflow="scroll">
            {this.renderTabOptions(this.props.configuration)}
          </SeTabbar>
          <TabContent id="modal-io-types-tabContent">
            <Scrollbars>
              {this.renderTabContent(this.props.configuration)}
            </Scrollbars>
          </TabContent>
        </Body>
      </Container>
    );
  }
}

export default ModalIOTypes;
